import { useEffect, useState } from "react";
import CryptoJS from "crypto-js";
const secret_key = "ZQESf6jViSOmswZ6FW76gS1gaF05lfkE";
const password = "3PHNrs9g96Q4lazVM9vPqXY";

const VipvCheck = () => {
    const [token, setToken] = useState("");
    const [sdkData, setSdkData] = useState(null);
    const [scriptUrl, setScriptUrl] = useState("");


    async function pbkdf2Sha1(secret, salt, iterations, totalBytes) {
        const enc = new TextEncoder();
        const keyMaterial = await crypto.subtle.importKey(
            "raw",
            enc.encode(secret),
            { name: "PBKDF2" },
            false,
            ["deriveBits"]
        );
        const bits = await crypto.subtle.deriveBits(
            { name: "PBKDF2", hash: "SHA-1", salt: enc.encode(salt), iterations },
            keyMaterial,
            totalBytes * 8
        );
        return new Uint8Array(bits);
    }

    function toUtf16LE(str) {
        const buf = new ArrayBuffer(str.length * 2);
        const view = new DataView(buf);
        for (let i = 0; i < str.length; i++) {
            view.setUint16(i * 2, str.charCodeAt(i), true); // little-endian = UTF-16LE
        }
        return new Uint8Array(buf);
    }

    async function encrypt(payload, secretKey, password) {
        // Derive 48 bytes in one continuous PBKDF2 call (matches .NET Rfc2898DeriveBytes)
        // First 32 bytes → AES-256 key, next 16 bytes → IV
        const derived = await pbkdf2Sha1(secretKey, password, 1000, 48);
        const aesKey = derived.slice(0, 32);
        const iv = derived.slice(32, 48);

        // Encode payload as UTF-16LE (matches C# Encoding.Unicode)
        const clearBytes = toUtf16LE(payload);

        const cryptoKey = await crypto.subtle.importKey(
            "raw", aesKey, { name: "AES-CBC" }, false, ["encrypt"]
        );

        // AES-CBC with PKCS7 padding (Web Crypto applies PKCS7 automatically)
        const encrypted = await crypto.subtle.encrypt(
            { name: "AES-CBC", iv }, cryptoKey, clearBytes
        );

        // Base64-encode the result (matches Convert.ToBase64String)
        return btoa(String.fromCharCode(...new Uint8Array(encrypted)));
    }


    const fetchToken = async () => {

        const payload = JSON.stringify({
            "s": "ab_rathi",
            "k": "wdL0iky6MZCRvwVMc4BPpqkg9iQZ1ULk",
            "request_id": "3EAE6C99-E834-499D-A0F5-33A03A739765",
            "ip": "000.00.00.00",
            "ts": "20251215120937",
            "user_type": "",
            "project_name": "",
            "redirect_url": "https://localhost:44329/Manual-IPV",
        });

        const encryptedString = await encrypt(payload, secret_key, password);
        console.log("Encrypted String:", encryptedString);
        setToken(encryptedString);
    };



    const handleSDKData = (data) => {
        setSdkData(data);
    };

    // window.AinxtSDK.Initialize(token, handleSDKData);
    function myFunction() {
        let s = "ab_rathi";
        window.AinxtSDK.Initialize(
            token,
            handleSDKData,
            s,
            token
        );
    }


    useEffect(() => {
        if (scriptUrl) {
            const script = document.createElement("script");
            script.src = scriptUrl;
            script.async = true;

            document.head.appendChild(script);

            return () => {
                document.head.removeChild(script);
            };
        }
    }, [scriptUrl]); // Dependency on scriptUrl

    return (
        <div className="text-center">
            <h1 className="text-4xl font-bold mb-8">Signature SDK Test 3</h1>
            <input
                type="text"
                placeholder="Enter Script URL"
                value={scriptUrl}
                onChange={(e) => setScriptUrl(e.target.value)}
                className="form-control"
                style={{
                    padding: "10px",
                    width: "300px",
                    // margin: "10px auto",
                    display: "block",
                    borderRadius: "5px",
                }}
            />
            {
                scriptUrl && (
                    <>
                        {token && (
                            <button
                                className="mt-4 bg-green-500 hover:bg-green-700 text-dark font-bold py-2 px-4 rounded"
                                onClick={myFunction}
                            >
                                Initialize AinxtSDK
                            </button>
                        )}
                    </>
                )
            }
            <button
                className="bg-blue-500 hover:bg-blue-700 text-dark font-bold py-2 px-4 rounded"
                onClick={fetchToken}
            >
                Get Token
            </button>

            {sdkData && (
                <div className="mt-4">
                    <h2 className="text-xl font-bold mb-2">Data from SDK:</h2>
                    <pre className="whitespace-pre-wrap font-bold">{JSON.stringify(sdkData, null, 2)}</pre>
                </div>
            )}
        </div>
    );
    
};

export default VipvCheck;

